import { AppointmentAttendanceStatus } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";

export const CaseNoteMaxLength = {
  noteType: 50,
  location: 30,
  result: 40,
};

export interface CaseNoteFormValues {
  type: string | null;
  date: Date | null;
  time: Date | null;
  assignedCounselorId: string | null;
  location: string | null;
  content: string | null;
  result: string | null;
  appointmentStatus: AppointmentAttendanceStatus | null;
}
